import logoDefender from '../../../../assets/images/logo-defender.svg'
import axios from 'axios'
import config from '../../../../config'
import BizinBackend from '../../../../helpers/bizin_helper'

export const exportDashboardToHTML = async (gridComponents, options = {}) => {
  const filename = options.filename || 'dashboard.html'
  const selector = options.selector || '.page-dash .dataTable-custom-primary'

  const includeFACss = options.includeFontAwesomeCss !== false
  const faCssUrl = options.faCssUrl || 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css'
  const reportCssUrl = options.reportCssUrl || (typeof window !== 'undefined' ? `${window.location.origin}/report-export.css` : '/report-export.css')
  const includeAppCss = options.includeAppCss !== false
  const includeGoogleFontsCss = options.includeGoogleFontsCss !== false
  const googleFontsUrl = options.googleFontsUrl || 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'
  const resolvedLogoUrl = options.logoUrl || (typeof window !== 'undefined' ? new URL(logoDefender, window.location.origin).href : logoDefender)

  const container = typeof document !== 'undefined' ? document.querySelector(selector) : null
  if (!container) throw new Error('Container do dashboard não encontrado')

  const appCssLinks = includeAppCss && typeof window !== 'undefined'
    ? (() => {
        try {
          const hrefs = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map(l => l && l.href)
            .filter(Boolean)
          const unique = Array.from(new Set(hrefs))
          const linksStr = unique
            .map(href => { try { return new URL(href, window.location.origin).href } catch { return href } })
            .map(abs => `<link rel="stylesheet" href="${abs}" />`)
            .join('\n')
          const styleTags = Array.from(document.querySelectorAll('style'))
            .map(s => s && s.textContent)
            .filter(css => css && css.trim().length > 0)
          const inlineStr = styleTags.length ? `<style>\n${styleTags.join('\n\n')}\n</style>` : ''
          return `${linksStr}\n${inlineStr}`
        } catch { return '' }
      })()
    : ''

  const dashboardCss = (() => {
    if (typeof options.extraCss === 'string') return options.extraCss
    return `

      body * {
          outline: none;
          font-family: "Poppins", sans-serif;
      }

      .font-w-600 {
          font-weight: 600 !important;
      }
      .font-size-16 {
          font-size: 1rem !important;
      }
      .text-color-azul1 {
          --bs-text-opacity: 1;
          color: rgba(var(--bs-color-azul1-rgb), var(--bs-text-opacity)) !important;
      }

      .card-dash-item {
          height: auto;
          margin-bottom: 0px;
          min-height: 134px;
      }

      .card {
          border-radius: 12px !important;
          box-shadow: none;
      }

      .accordion-item-dash {
        background-color: #D6D9E2 !important;
        padding: 14px;
        border-radius: 10px 10px 10px 10px !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3), 0 0 0 8px #f8f9fa00;
      }

      .accordion-body-dash > div {
          gap: 16px !important;
      }

      .align-items-end {
          align-items: flex-end !important;
      }

      .dados-listas {
          flex: 1 1 !important;
          width: 100%;
          overflow-y: auto;
      }
      .dados-lista { width: 100% !important; }

      .list-dados {
          list-style: none;
          padding: 0;
          margin: 0;
          margin-top: 8px;
          max-width: 100%;
      }

      /* Centralização apenas quando tem classes de flex do Bootstrap */
      .list-dados.d-flex.flex-column.align-items-center.justify-content-center {
          margin: 0 auto;
          text-align: center !important;
      }

      .list-dados li:not(:last-child) {
          margin-bottom: 5px;
      }

      /* Centralização dos li apenas quando o ul tem classes de flex */
      .list-dados.d-flex.flex-column.align-items-center.justify-content-center li {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          width: 100% !important;
          text-align: center !important;
      }

      /* Alinhamento à esquerda para os outros casos */
      .list-dados:not(.d-flex) li,
      .list-dados:not(.align-items-center) li {
          display: flex;
          justify-content: space-between !important;
          align-items: center !important;
          width: 100% !important;
      }

      .font-size-14 {
          font-size: 14px !important;
      }
      .text-black {
          --bs-text-opacity: 1;
          color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
      }

      .mt-1.d-flex.align-items-end.justify-content-end {
          justify-content: space-between !important;
          align-items: center !important;
          width: 100% !important;
      }

      .cardbody-dash.card-body {
        padding-top: 0.75rem !important;
        padding-bottom: 0 !important;
      }
      .cardbody-dash h6 { margin-top: 0.5rem !important; }

      .infoIcon-IND_DF_LO0002,
      [class^="infoIcon-"],
      [class*=" infoIcon-"],
      [class*="fa-info-circle"],
      [class*="fa-circle-info"],
      [class*="pi-info-circle"] {
        display: none !important;
        }
        
        .dashboard-export-wrapper {
            padding: 0px 10px;
        }

        /* Centralizar gráficos de pizza e outros gráficos */
        .recharts-wrapper,
        .recharts-surface,
        [class*="recharts"] {
            margin: 0 auto !important;
            display: block !important;
        }

        /* Centralizar canvas e svg de gráficos */
        .card-body canvas,
        .card-body svg,
        canvas[class*="chart"],
        svg[class*="chart"],
        canvas,
        svg {
            margin: 0 auto !important;
            display: block !important;
        }

        /* Centralizar containers de gráficos */
        [class*="PieChart"],
        [class*="pie-chart"],
        [class*="chart-container"],
        div[class*="chart"],
        div[class*="Chart"] {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            text-align: center !important;
            margin: 0 auto !important;
        }

        /* Legenda horizontal para gráficos */
        .recharts-legend-wrapper,
        [class*="recharts-legend"] {
            display: flex !important;
            flex-direction: row !important;
            justify-content: center !important;
            align-items: center !important;
            flex-wrap: wrap !important;
        }

        .recharts-legend-item,
        [class*="recharts-legend-item"] {
            display: inline-flex !important;
            flex-direction: row !important;
            align-items: center !important;
            margin: 0 8px !important;
        }

    `
  })()

  const safeGet = (fn, fallback = '') => { try { const v = fn(); return v == null ? fallback : v } catch { return fallback } }
  const pageTitle = options.title || 'Dashboard de Gráficos'
  const transactionCode = options.transactionCode || safeGet(() => {
    const head = []
    const node = Array.isArray(head) ? head.find(c => c.Chave_Transacao_Componente === 'CODIGO_TRANSACAO' || c.Chave_Transacao_Componente === 'Codigo_Transacao') : null
    return node?.Valor_Componente
  }, '')

  const buildFilterPills = (applied) => {
    if (!applied || !applied[0] || Object.keys(applied[0]).length === 0) return []
    const pills = []
    const filterObj = applied[0]
    Object.keys(filterObj).forEach((key) => {
      const filter = filterObj[key]
      if (Array.isArray(filter)) {
        if (filter[0]?.values && filter[0]?.field) {
          filter[0].values.forEach((v) => pills.push(String(v.label || v.value)))
        }
      } else if (filter && typeof filter === 'object') {
        const value = filter.label || filter.value
        if (value) pills.push(String(value))
      }
    })
    return pills
  }
  const filterPills = buildFilterPills(options.appliedFilters)

  const headerFooterHtml = `
    <div class="defender-header">
      <div class="defender-logo">
        <img src="${String(resolvedLogoUrl)}" alt="Defender" class="defender-logo-img"/>
      </div>
      <div class="report-title">${String(pageTitle)}</div>
    </div>
  `

  const filtersBarHtml = `
    <div class="filters-bar">
      <div class="filters-left">
        ${filterPills.length > 0 ? `
        <span class="filters-title">Filtros aplicados:</span>
        <span class="filter-list">${filterPills.map(p => `<span class="filter-pill">${String(p)}</span>`).join('')}</span>
        ` : ''}
      </div>
      <div class="code-display"><b>Código:</b> ${String(transactionCode || '')}</div>
    </div>
  `

  const clone = container.cloneNode(true)
  try {
    const removeSelectors = Array.isArray(options.removeSelectors) && options.removeSelectors.length
      ? options.removeSelectors
      : [
          '.nav-accordion-custom',
          '.d-flex.align-items-center.ms-auto.flex-shrink-0',
          '.infoIcon-IND_DF_LO0002',
          '[class^="infoIcon-"]',
          '[class*=" infoIcon-"]',
          '#infoIcon-IND_VS_RL0003',
          '[id^="infoIcon-"]',
          '[class*="fa-info-circle"]',
          '[class*="fa-circle-info"]',
          '[class*="pi-info-circle"]'
        ]
    removeSelectors.forEach(sel => {
      try { clone.querySelectorAll(sel).forEach(n => n && n.parentNode && n.parentNode.removeChild(n)) } catch {}
    })
    const hideSelectors = Array.isArray(options.hideSelectors) && options.hideSelectors.length
      ? options.hideSelectors
      : []
    hideSelectors.forEach(sel => {
      try {
        clone.querySelectorAll(sel).forEach(n => {
          try { n.style.setProperty('display', 'none', 'important') } catch {}
        })
      } catch {}
    })
  } catch {}

  try {
    if (options.inlineComputedStyles) {
      const properties = Array.isArray(options.inlineProps) && options.inlineProps.length
        ? options.inlineProps
        : [
            'background', 'background-color', 'background-image', 'background-size', 'background-position', 'background-repeat',
            'color', 'font', 'font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'text-align', 'text-transform', 'letter-spacing',
            'display', 'visibility', 'opacity',
            'width', 'height', 'min-width', 'min-height', 'max-width', 'max-height',
            'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
            'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
            'border', 'border-radius', 'border-color', 'border-width', 'border-style',
            'box-shadow', 'overflow', 'overflow-x', 'overflow-y',
            'position', 'top', 'right', 'bottom', 'left', 'z-index',
            'gap', 'row-gap', 'column-gap',
            'align-items', 'justify-content', 'align-content', 'justify-items',
            'grid', 'grid-template-columns', 'grid-template-rows', 'grid-auto-rows', 'grid-column', 'grid-row',
            'flex', 'flex-direction', 'flex-wrap', 'flex-grow', 'flex-shrink', 'flex-basis', 'align-self', 'order'
          ]
      const elements = [clone, ...Array.from(clone.querySelectorAll('*'))]
      elements.forEach(el => {
        try {
          const cs = window.getComputedStyle(el)
          let cssText = el.getAttribute('style') || ''
          properties.forEach(prop => {
            const v = cs.getPropertyValue(prop)
            if (v) cssText += `${prop}: ${v};`
          })
          if (cssText) el.setAttribute('style', cssText)
        } catch {}
      })
    }
  } catch {}
  try {
    const originalCanvases = Array.from(container.querySelectorAll('canvas'))
    const clonedCanvases = Array.from(clone.querySelectorAll('canvas'))
    const count = Math.min(originalCanvases.length, clonedCanvases.length)
    for (let i = 0; i < count; i++) {
      const cv = originalCanvases[i]
      const target = clonedCanvases[i]
      try {
        const dataUrl = cv.toDataURL('image/png')
        const img = document.createElement('img')
        img.setAttribute('src', dataUrl)
        if (cv.width) img.style.width = `${cv.width}px`
        if (cv.height) img.style.height = `${cv.height}px`
        target.parentNode && target.parentNode.replaceChild(img, target)
      } catch {}
    }
  } catch {}

  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8" />
  <title>${String(pageTitle)}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <link rel="stylesheet" href="${reportCssUrl}" />
  ${includeGoogleFontsCss ? `<link rel="stylesheet" href="${googleFontsUrl}" />` : ''}
  ${includeFACss ? `<link rel="stylesheet" href="${faCssUrl}" crossorigin="anonymous" referrerpolicy="no-referrer" />` : ''}
  ${appCssLinks}
  <style>
  
   body {
        zoom: 80% !important;
      }

     .main-content {      
        margin: 0 !important;
        padding: 0 !important;
    }

    .card-body img    {
        width: 100% !important;        
    }

  ${dashboardCss}</style>
</head>
<body>
  ${headerFooterHtml}
  ${filtersBarHtml}
  <div class="main-content">
    <div class="dashboard-export-wrapper">${clone.innerHTML}</div>
  </div>
</body>
</html>`

  const convertToPdf = options.convertToPdf !== false
  
  if (!convertToPdf) {
    const blob = new Blob([html], { type: 'text/html;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    return
  }

  try {
    let csrfToken
    try {
      const csrfResponse = await BizinBackend.getCsrfToken()
      csrfToken = csrfResponse?.csrfToken || csrfResponse
    } catch (error) {
      const response = await axios.get(`${config.URL_SERVER}/_get_csrf_token`, {
        headers: { 'Origin': window.location.origin }
      })
      csrfToken = response.data?.csrfToken
    }

    if (!csrfToken) {
      throw new Error('Não foi possível obter CSRF token')
    }

    const saveResponse = await axios.post(
      `${config.URL_SERVER}/salvar-html-temporario`,
      { html },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        timeout: 30000
      }
    )
    
    const tempUrl = saveResponse.data.url
    
    const response = await axios.post(
      `${config.URL_SERVER}/gerar-pdf`,
      { 
        parameters: {
          url: tempUrl
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        responseType: 'blob',
        timeout: 180000
      }
    )

    const contentType = response.headers['content-type'] || response.headers['Content-Type']
    
    const isPdfContentType = contentType === 'application/pdf' || contentType?.includes('pdf')
    
    const hasData = response.data instanceof Blob && response.data.size > 0
    
    let hasPdfSignature = false
    if (response.data instanceof Blob) {
      const firstBytes = await response.data.slice(0, 4).text()
      hasPdfSignature = firstBytes.startsWith('%PDF')
    }
    
    const isPdf = isPdfContentType && hasData && hasPdfSignature
    
    if (response.data && isPdf) {
      const pdfBlob = response.data instanceof Blob 
        ? response.data 
        : new Blob([response.data], { type: 'application/pdf' })
      
      const link = document.createElement('a')
      const url = URL.createObjectURL(pdfBlob)
      const pdfFilename = filename.endsWith('.pdf') ? filename : filename.replace(/\.html?$/, '.pdf')
      link.setAttribute('href', url)
      link.setAttribute('download', pdfFilename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } else {
      throw new Error(`Resposta da API não é um PDF válido. Content-Type: ${contentType}, Status: ${response.status}`)
    }
  } catch (error) {
    throw new Error(`Erro ao gerar PDF: ${error.message}. Verifique o console para mais detalhes.`)
  }
}

export default exportDashboardToHTML


